import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';

import constant from '@/util/constant.js';
const api = {
    fetchData: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/getsprint/sprintlist", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;

